import React, { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import { useUserInfor } from "../../../../../Context/User";
import { ObterFormularioProdutoController } from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";

interface IVisualizarFormularioProdutoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    ID_EMPREENDIMENTO: number;
}

export default function VisualizarFormularioProduto(
    props: IVisualizarFormularioProdutoProps
) {
    const { UserInfor } = useUserInfor();

    const {
        value: lstFormularioProduto,
        loading: lstFormularioProdutoLoading,
        // execute: updateList
    } = useAsyncEffect(() =>
        ObterFormularioProdutoController(props.ID_EMPREENDIMENTO, true)
    );

    return (
        <>
            <OrSpinner spinner="capys" loading={lstFormularioProdutoLoading}>
                <UnForm handleSubmit={() => {}}>
                    {lstFormularioProduto?.PERGUNTAS.map((pergunta, index) => (
                        <div key={pergunta.ID_FORMULARIO_PRODUTO_PERGUNTA}>
                            <div className="d-flex align-items-center g-3 ml-8 row">
                                <h4 className="mt-3 mb-4">
                                    {pergunta.DS_PERGUNTA}
                                </h4>
                            </div>

                            <div className="d-flex justify-content-center mb-4">
                                {pergunta.RESPOSTAS?.map((resposta) =>
                                    pergunta.ID_TIPO_PERGUNTA !== 3 ? (
                                        <label
                                            key={
                                                resposta.ID_FORMULARIO_PRODUTO_RESPOSTA
                                            }
                                            className="d-flex flex-wrap align-items-center mb-3 me-3 radio-option"
                                        >
                                            <UnForm.Input
                                                type="radio"
                                                disabled
                                                label={resposta.DS_RESPOSTA}
                                                value={
                                                    resposta.ID_FORMULARIO_PRODUTO_RESPOSTA
                                                }
                                                defaultChecked={
                                                    resposta.ID_FORMULARIO_PRODUTO_RESPOSTA ===
                                                    pergunta.RESPOSTA_ESCOLHIDA
                                                        ?.ID_FORMULARIO_PRODUTO_RESPOSTA
                                                }
                                                name={`${index}.ID_FORMULARIO_PRODUTO_RESPOSTA`}
                                            />
                                        </label>
                                    ) : null
                                )}
                            </div>
                            <UnForm.Textarea
                                label="Comentário"
                                name={`${index}.DS_COMENTARIO`}
                                defaultValue={
                                    pergunta.RESPOSTA_ESCOLHIDA?.DS_COMENTARIO
                                }
                                disabled
                            />

                            <UnForm.Input
                                name={`${index}.ID_USUARIO_RESPOSTA`}
                                value={UserInfor.ID_USUARIO ?? 0}
                                style={{
                                    display: "none",
                                }}
                                wrapperClassName="d-none"
                            />

                            <hr />
                        </div>
                    ))}
                </UnForm>
            </OrSpinner>
        </>
    );
}
